<template>
  <div class="servicos-categorias-page">
    <Box :title="t('Categorias dos Serviços')" icon="pi pi-list">
      <template #actions>
        <Button
          :label="t('Novo')"
          icon="pi pi-plus"
          data-testid="servicos-categorias-new-button"
          @click="handleNewCategoria" />
      </template>
      <servicos-categorias-table
        ref="tableRef"
        @edit="handleEditCategoria">
      </servicos-categorias-table>
    </Box>

    <!-- ServicosCategoriasModal is centralized in ModalManager.vue - opened via eventBus -->
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../eventBus';
import { log } from '../../utils/DebugLogger';
import ServicosCategoriasTable from './ServicosCategoriasTable.vue';
// ServicosCategoriasModal is centralized in ModalManager.vue

const { t } = useI18n();

const tableRef = ref<unknown>(null);

const handleNewCategoria = (): void => {
  log('ServicosCategoriasPage', 'handleNewCategoria', 'Emitting modal open event for new categoria');
  eventBus.emit('modal.servicos-categorias.open', { id: null });
};

const handleEditCategoria = (categoriaId: number | string): void => {
  log('ServicosCategoriasPage', 'handleEditCategoria', 'Emitting modal open event for edit', categoriaId);
  eventBus.emit('modal.servicos-categorias.open', { id: categoriaId });
};

onMounted(() => {
  log('ServicosCategoriasPage', 'mounted', 'Component mounted');
});
</script>

<style scoped>
.servicos-categorias-page {
  padding: 0;
}
</style>
